// eslint:disable max-func-body-length
import * as React from 'react';
import { Link } from 'react-router-dom';
import { logout } from 'app/shell/logout';
import { CloseOnBlur } from 'ui/common/close-on-blur';
import { routeConstants, UserProfileSectionType } from 'app/routes/route-constants';
import { HeaderProps, HeaderState } from '../../types';
import { isValidUrl } from 'app/infrastructure/validation/url';
import { FixedDocument } from 'app/components/fixed-document';
import { Link as ExternalLink } from 'ui';
import {
  MdEqualizer as MdCharts,
  MdAdd,
  MdAccountCircle as MdUser,
  MdSearch,
  MdTrendingUp,
  MdMenu as MdBurger,
  MdClose,
  MdFileDownload,
  MdHelp,
  MdMailOutline as MdMessage,
  MdFeedback,
  MdPlaylistAddCheck,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdAssignment,
  MdBuild,
  MdTranslate,
  MdLink,
  MdCable,
  MdOutlineAutoAwesome
} from 'react-icons/md';
import {
  FaSignOutAlt as FaSignOut,
  FaSyncAlt as FaRefresh,
  FaSitemap
} from 'react-icons/fa';
import { urlToSurveyManager } from 'app/area/favourite/components/url-to-survey-manager';
import { shouldShowToolsMenu } from 'app/shell/should-show-tools-menu';
import { getAiChatBaseUrl, getSctwLink } from 'app/infrastructure/hosting';
import { urlToAiChat } from 'app/infrastructure/js/url-to-ai-chat';
import styles from './mobile-nav.scss';

const AiChat = ({ aiChatAssistantAccessInfo, instanceInfo, translation, onClick }) =>
  aiChatAssistantAccessInfo?.aiAdvisor
  && isValidUrl(urlToAiChat(getAiChatBaseUrl(), instanceInfo))
  && (
    <li onClick={onClick}>
      <Link
        className="list-group-item"
        to={urlToAiChat(getAiChatBaseUrl(), instanceInfo)}
        target="_blank"
        rel="noreferrer">
        <MdOutlineAutoAwesome id="nav-ai-chat-icon" className={styles.navItemIcon} />
        <span className={styles.navItemText}>{translation.ai_chat_title}</span>
      </Link>
    </li>
  );

export class MobileNav extends React.Component<HeaderProps, HeaderState> {

  public state: Readonly<HeaderState> = {
    menuIsOpen: false,
    menuIsClosing: false
  };

  private openMenu = () => {
    this.setState({ menuIsOpen: true });
  };

  private closeMenu = () => {
    this.setState({ menuIsClosing: true });
    setTimeout(() => {
      this.setState({
        menuIsOpen: false,
        menuIsClosing: false
      });
    }, 300);
  };

  public render() {
    const { translation, menuAccess, manageSurveysUrl, aiChatAssistantAccessInfo } = this.props;
    return (
      <CloseOnBlur onBlur={this.closeMenu}>
        <div className={styles.mobileNav}>
          <div className="container main-grid">

            {!this.state.menuIsOpen &&
              <button className={`btn ${styles.hamburger}`} onClick={this.openMenu}>
                <span>{translation.menu}</span>
                <MdBurger className={styles.navItemIcon} />
              </button>
            }

            {this.state.menuIsOpen &&
              <button className={`btn ${styles.hamburger}`} id={styles.closeBtn} onClick={this.closeMenu}>
                <span>{translation.menu}</span>
                <MdClose className={styles.navItemIcon} />
              </button>
            }
          </div>

          {this.state.menuIsOpen &&
            <FixedDocument>
              <div>
                <ul className={`list-group dropdown-menu ${styles.dropdownList}
              ${this.state.menuIsClosing ? styles.animateOut : ''}`}>
                  <li onClick={this.closeMenu}>
                    <Link to={routeConstants.selectCaseType} className="list-group-item">
                      <MdAdd className={styles.navItemIcon} />
                      <span className={styles.navItemText}>{translation.new_case}</span>
                    </Link>
                  </li>

                  <li>
                    <input type="checkbox" id="mobile-dashboards" />

                    <div className={`${styles.dropdownButton} list-group-item`}>
                      <MdCharts className={styles.navItemIcon} />
                      <span className={`${styles.navItemText} ${styles.small}`}>
                        {translation.dashboards}
                      </span>
                      <label className={styles.dropdownLabel} htmlFor="mobile-dashboards">
                        <MdKeyboardArrowDown className={styles.down} />
                        <MdKeyboardArrowUp className={styles.up} />
                      </label>
                    </div>

                    <ul className={styles.subMenu}>
                      <li onClick={this.closeMenu}>
                        <Link to={routeConstants.selectDashboard} className="list-group-item">
                          <MdTrendingUp className={styles.navItemIcon} />
                          <span className={styles.navItemText}>{translation.dashboards}</span>
                        </Link>
                      </li>
                      <li onClick={this.closeMenu}>
                        <Link to={routeConstants.selectSavedDashboards} className="list-group-item">
                          <MdTrendingUp className={styles.navItemIcon} />
                          <span className={styles.navItemText}>{translation.saved_dashboards}</span>
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <AiChat
                    aiChatAssistantAccessInfo={aiChatAssistantAccessInfo}
                    instanceInfo={this.props.instanceInfo}
                    translation={translation}
                    onClick={this.closeMenu}
                  />
                  <li onClick={this.closeMenu}>
                    <Link className="list-group-item" to={routeConstants.createFavouriteDraft}>
                      <MdSearch id="nav-search-icon" className={styles.navItemIcon} />
                      <span className={styles.navItemText}>{translation.search}</span>
                    </Link>
                  </li>

                  <li onClick={this.closeMenu}>
                    <Link to={routeConstants.userProfileActiveSection(UserProfileSectionType.Settings)} className="list-group-item">
                      <MdUser className={styles.navItemIcon} />
                      <span className={styles.navItemText}>{translation.user_profile}</span>
                    </Link>
                  </li>

                  <li onClick={this.closeMenu}>
                    <Link to={routeConstants.myCaseDraftsView} className="list-group-item">
                      <MdFileDownload className={styles.navItemIcon} />
                      <span className={styles.navItemText}>{translation.my_case_drafts_title}</span>
                    </Link>
                  </li>

                  <li onClick={this.closeMenu}>
                    <Link to={routeConstants.myDownloadsView} className="list-group-item">
                      <MdFileDownload className={styles.navItemIcon} />
                      <span className={styles.navItemText}>{translation.my_downloads_title}</span>
                    </Link>
                  </li>

                  <li>
                    <input type="checkbox" id="mobile-reports" />

                    <div className={`${styles.dropdownButton} list-group-item`}>
                      <MdAssignment className={styles.navItemIcon} />
                      <span className={`${styles.navItemText} ${styles.small}`}>
                        {translation.reports}
                      </span>
                      <label className={styles.dropdownLabel} htmlFor="mobile-reports">
                        <MdKeyboardArrowDown className={styles.down} />
                        <MdKeyboardArrowUp className={styles.up} />
                      </label>
                    </div>

                    <ul className={styles.subMenu}>
                      <li onClick={this.closeMenu}>
                        <Link to={routeConstants.favouriteDraftNew} className="list-group-item">
                          <MdTrendingUp className={styles.navItemIcon} />
                          <span className={styles.navItemText}>{translation.new_report}</span>
                        </Link>
                      </li>
                      <li onClick={this.closeMenu}>
                        <Link to={routeConstants.selectSavedReports} className="list-group-item">
                          <MdTrendingUp className={styles.navItemIcon} />
                          <span className={styles.navItemText}>{translation.reports_saved}</span>
                        </Link>
                      </li>
                      <li onClick={this.closeMenu}>
                        <Link to={routeConstants.selectCompanyReports} className="list-group-item">
                          <MdTrendingUp className={styles.navItemIcon} />
                          <span className={styles.navItemText}>{translation.reports_company}</span>
                        </Link>
                      </li>
                      <li onClick={this.closeMenu}>
                        <Link to={routeConstants.selectSavedCompanyReports} className="list-group-item">
                          <MdTrendingUp className={styles.navItemIcon} />
                          <span className={styles.navItemText}>{translation.saved_reports_company}</span>
                        </Link>
                      </li>
                    </ul>
                  </li>

                  {shouldShowToolsMenu(menuAccess) && <li>
                    <input type="checkbox" id="mobile-admin" />

                    <div className={`${styles.dropdownButton} list-group-item`}>
                      <MdBuild className={styles.navItemIcon} />
                      <span className={`${styles.navItemText} ${styles.small}`}>
                        {translation.tools}
                      </span>
                      <label className={styles.dropdownLabel} htmlFor="mobile-admin">
                        <MdKeyboardArrowDown className={styles.down} />
                        <MdKeyboardArrowUp className={styles.up} />
                      </label>
                    </div>

                    <ul className={styles.subMenu}>
                      {menuAccess.codetableAdministration &&
                        <li onClick={this.closeMenu}>
                          <Link to={routeConstants.selectCodetableAdministration} className="list-group-item">
                            <FaSitemap className={styles.navItemIcon} />
                            <span className={styles.navItemText}>
                              {translation.codetable_administration}
                            </span>
                          </Link>
                        </li>
                      }

                      {menuAccess.userAdministration &&
                        <li onClick={this.closeMenu}>
                          <Link to={routeConstants.userSearchView} className="list-group-item">
                            <MdUser className={styles.navItemIcon} />
                            <span className={styles.navItemText}>
                              {translation.user_administration}
                            </span>
                          </Link>
                        </li>
                      }

                      {menuAccess.roleAdministration &&
                        <li onClick={this.closeMenu}>
                          <Link to={routeConstants.rolesView} className="list-group-item">
                            <MdUser className={styles.navItemIcon} />
                            <span className={styles.navItemText}>
                              {translation.role_administration}
                            </span>
                          </Link>
                        </li>
                      }

                      {(menuAccess.dashboardAdministration || menuAccess.companyReportAdministration
                        || menuAccess.favouriteAdministration) &&
                        <li>
                          <input type="checkbox" id="mobile-admin-dashboards-reports" />

                          <div className={`${styles.dropdownButton} list-group-item`}>
                            <MdCharts className={styles.navItemIcon} />
                            <span className={`${styles.navItemText} ${styles.small}`}>
                              {translation.dashboards_and_reports}
                            </span>
                            <label className={styles.dropdownLabel} htmlFor="mobile-admin-dashboards-reports">
                              <MdKeyboardArrowDown className={styles.down} />
                              <MdKeyboardArrowUp className={styles.up} />
                            </label>
                          </div>

                          <ul className={styles.subMenu}>
                            {menuAccess.dashboardAdministration &&
                              <li className={styles.child} onClick={this.closeMenu}>
                                <Link to={routeConstants.dashboardAdminList} className="list-group-item">
                                  <span className={styles.navItemText}>
                                    {translation.manage_dashboard}
                                  </span>
                                </Link>
                              </li>
                            }
                            {menuAccess.companyReportAdministration &&
                              <li className={styles.child} onClick={this.closeMenu}>
                                <Link to={routeConstants.companyReportAdminList} className="list-group-item">
                                  <span className={styles.navItemText}>
                                    {translation.reports_company}
                                  </span>
                                </Link>
                              </li>
                            }
                            {menuAccess.favouriteAdministration &&
                              <li className={styles.child} onClick={this.closeMenu}>
                                <Link to={routeConstants.favouriteAdminList} className="list-group-item" >
                                  <span className={styles.navItemText}>
                                    {translation.manage_favourites}
                                  </span>
                                </Link>
                              </li>
                            }
                          </ul>
                        </li>}

                      {menuAccess.importSetsAdministration &&
                        <li>
                          <input type="checkbox" id="mobile-admin-import-sets" />
                          <div className={`${styles.dropdownButton} list-group-item`}>
                            <MdCharts className={styles.navItemIcon} />
                            <span className={`${styles.navItemText} ${styles.small}`}>
                              {translation.code_mapping_administration}
                            </span>
                            <label className={styles.dropdownLabel} htmlFor="mobile-admin-import-sets">
                              <MdKeyboardArrowDown className={styles.down} />
                              <MdKeyboardArrowUp className={styles.up} />
                            </label>
                          </div>

                          <ul className={styles.subMenu}>
                            <li className={styles.child} onClick={this.closeMenu}>
                              <Link to={routeConstants.importSetList} className="list-group-item">
                                <span className={styles.navItemText}>
                                  {translation.manage_import_sets}
                                </span>
                              </Link>
                            </li>
                            <li className={styles.child} onClick={this.closeMenu}>
                              <Link to={routeConstants.importMappings} className="list-group-item">
                                <span className={styles.navItemText}>
                                  {translation.manage_code_mappings}
                                </span>
                              </Link>
                            </li>
                          </ul>
                        </li>}

                      {menuAccess.experienceTransferAdministration &&
                        <li>
                          <input type="checkbox" id="mobile-admin-experience-transfer" />

                          <div className={`${styles.dropdownButton} list-group-item`}>
                            <MdCable className={styles.navItemIcon} />
                            <span className={`${styles.navItemText} ${styles.small}`}>
                              {translation.experience_transfer_administration}
                            </span>
                            <label className={styles.dropdownLabel} htmlFor="mobile-admin-experience-transfer">
                              <MdKeyboardArrowDown className={styles.down} />
                              <MdKeyboardArrowUp className={styles.up} />
                            </label>
                          </div>

                          <ul className={styles.subMenu}>
                            <li className={styles.child} onClick={this.closeMenu}>
                              <Link to={routeConstants.subscriberGroupsList} className="list-group-item">
                                <span className={styles.navItemText}>
                                  {translation.subscriber_groups_administration}
                                </span>
                              </Link>
                            </li>
                            <li className={styles.child} onClick={this.closeMenu}>
                              <Link to={routeConstants.subscriberGroupsUserMembers} className="list-group-item">
                                <span className={styles.navItemText}>
                                  {translation.user_members_administration}
                                </span>
                              </Link>
                            </li>
                            <li className={styles.child} onClick={this.closeMenu}>
                              <Link to={routeConstants.experienceTransferList} className="list-group-item">
                                <span className={styles.navItemText}>
                                  {translation.experience_transfer_configuration}
                                </span>
                              </Link>
                            </li>
                            <li className={styles.child} onClick={this.closeMenu}>
                              <Link to={routeConstants.experienceTransferOperations} className="list-group-item">
                                <span className={styles.navItemText}>
                                  {translation.configure_operations_transfer}
                                </span>
                              </Link>
                            </li>
                          </ul>
                        </li>}

                      {menuAccess.messageAdministration &&
                        <li onClick={this.closeMenu}>
                          <Link to={routeConstants.administrationMessagesList} className="list-group-item">
                            <MdMessage className={styles.navItemIcon} />
                            <span className={styles.navItemText}>
                              {translation.messages_to_users}
                            </span>
                          </Link>
                        </li>
                      }

                      {menuAccess.externalUrlAdministration &&
                        <li>
                          <input type="checkbox" id="mobile-admin-external-urls" />

                          <div className={`${styles.dropdownButton} list-group-item`}>
                            <MdLink className={styles.navItemIcon} />
                            <span className={`${styles.navItemText} ${styles.small}`}>
                              {translation.external_urls}
                            </span>
                            <label className={styles.dropdownLabel} htmlFor="mobile-admin-external-urls">
                              <MdKeyboardArrowDown className={styles.down} />
                              <MdKeyboardArrowUp className={styles.up} />
                            </label>
                          </div>

                          <ul className={styles.subMenu}>
                            <li className={styles.child} onClick={this.closeMenu}>
                              <Link to={routeConstants.externalUrlList} className="list-group-item">
                                <span className={styles.navItemText}>
                                  {translation.external_url}
                                </span>
                              </Link>
                            </li>
                            <li className={styles.child} onClick={this.closeMenu}>
                              <Link to={routeConstants.externalUrlGroupsList} className="list-group-item">
                                <span className={styles.navItemText}>
                                  {translation.external_url_groups}
                                </span>
                              </Link>
                            </li>
                          </ul>
                        </li>}

                      {menuAccess.manageSurveys && manageSurveysUrl && isValidUrl(urlToSurveyManager(manageSurveysUrl)) &&
                        <li>
                          <ExternalLink url={urlToSurveyManager(manageSurveysUrl)} className={'list-group-item'}>
                            <MdPlaylistAddCheck className={styles.navItemIcon} />
                            <span className={`${styles.navItemText} ${styles.small}`}>
                              {translation.manage_surveys}
                            </span>
                          </ExternalLink>
                        </li>}

                      {menuAccess.imports && <li onClick={this.closeMenu}>
                        <Link to={routeConstants.importView} className="list-group-item">
                          <MdTrendingUp className={styles.navItemIcon} />
                          <span className={styles.navItemText}>{translation.import_title}</span>
                        </Link>
                      </li>}

                      {menuAccess.textConfiguration &&
                        <li>
                          <input type="checkbox" id="mobile-admin-translations" />

                          <div className={`${styles.dropdownButton} list-group-item`}>
                            <MdTranslate className={styles.navItemIcon} />
                            <span className={`${styles.navItemText} ${styles.small}`}>
                              {translation.translations}
                            </span>
                            <label className={styles.dropdownLabel} htmlFor="mobile-admin-translations">
                              <MdKeyboardArrowDown className={styles.down} />
                              <MdKeyboardArrowUp className={styles.up} />
                            </label>
                          </div>

                          <ul className={styles.subMenu}>
                            <li className={styles.child} onClick={this.closeMenu}>
                              <Link to={routeConstants.textConfigurationList} className="list-group-item">
                                <span className={styles.navItemText}>
                                  {translation.texts}
                                </span>
                              </Link>
                            </li>
                            <li className={styles.child} onClick={this.closeMenu}>
                              <Link to={routeConstants.codeDescriptionList} className="list-group-item">
                                <span className={styles.navItemText}>{translation.code_descriptions}</span>
                              </Link>
                            </li>
                          </ul>
                        </li>}

                      {(menuAccess.refreshCache || menuAccess.regenerateAggregatedData) &&
                        <li>
                          <input type="checkbox" id="mobile-admin-other-tools" />

                          <div className={`${styles.dropdownButton} list-group-item`}>
                            <FaRefresh className={styles.navItemIcon} />
                            <span className={`${styles.navItemText} ${styles.small}`}>
                              {translation.other_tools}
                            </span>
                            <label className={styles.dropdownLabel} htmlFor="mobile-admin-other-tools">
                              <MdKeyboardArrowDown className={styles.down} />
                              <MdKeyboardArrowUp className={styles.up} />
                            </label>
                          </div>

                          <ul className={styles.subMenu}>
                            {menuAccess.refreshCache && <li className={styles.child}>
                              <button type="button" id="nav-logout-button" className="list-group-item" onClick={this.props.onRefreshCache}>
                                <span className={styles.navItemText}>{translation.refresh_cache_title}</span>
                              </button>
                            </li>}

                            {menuAccess.regenerateAggregatedData && <li className={styles.child}>
                              <button type="button" onClick={this.props.onRegenerateAggregatedEnv}
                                className="list-group-item">
                                <span className={`${styles.navItemText} ${styles.small}`}>
                                  {translation.regenerate_aggregated_environmental_data}
                                </span>
                              </button>
                            </li>}

                            {menuAccess.regenerateAggregatedData && <li className={styles.child}>
                              <button type="button" onClick={this.props.onRegenerateAggregatedRisk}
                                className="list-group-item">
                                <span className={`${styles.navItemText} ${styles.small}`}>
                                  {translation.regenerate_aggregated_risk_data}
                                </span>
                              </button>
                            </li>}

                            {getSctwLink() && isValidUrl(getSctwLink()) && <li className={styles.child}>
                              <ExternalLink url={getSctwLink()} className={'list-group-item'}>
                                <span className={`${styles.navItemText} ${styles.small}`}>
                                  {translation.system_configuration_tool}
                                </span>
                              </ExternalLink>
                            </li>}
                          </ul>
                        </li>}
                    </ul>
                  </li>}

                  {isValidUrl(this.props.helpUrl) &&
                    <li onClick={this.closeMenu}>
                      <ExternalLink url={this.props.helpUrl} className={'list-group-item'}>
                        <MdHelp className={styles.navItemIcon} />
                        <span className={`${styles.navItemText} ${styles.small}`}>
                          {translation.help}
                        </span>
                      </ExternalLink>
                    </li>}

                  <li onClick={this.closeMenu}>
                    <Link to={routeConstants.messagesToUserView} className="list-group-item">
                      <MdMessage className={styles.navItemIcon} />
                      <span className={`${styles.navItemText} ${styles.small}`}>
                        {translation.messages}
                      </span>
                    </Link>
                  </li>

                  {isValidUrl(this.props.feedbackUrl) &&
                    <li onClick={this.closeMenu}>
                      <ExternalLink url={this.props.feedbackUrl} className={'list-group-item'}>
                        <MdFeedback className={styles.navItemIcon} />
                        <span className={`${styles.navItemText} ${styles.small}`}>
                          {translation.feedback}
                        </span>
                      </ExternalLink>
                    </li>}

                  <li>
                    <button type="button" id="nav-logout-button" className="list-group-item" onClick={logout}>
                      <FaSignOut className={styles.navItemIcon} />
                      <span className={styles.navItemText}>{translation.logout}</span>
                    </button>
                  </li>
                </ul>
                <div className={`${styles.background} ${this.state.menuIsClosing ? styles.animateOut : ''}`} onClick={this.closeMenu} />
              </div>
            </FixedDocument>
          }
        </div>

      </CloseOnBlur>
    );
  }
}
